import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { titleFor } from './routeTitles';

/**
 * Accessibilité des changements de route (spec 08 §4.5) : pose le
 * `document.title`, remonte le scroll et ANNONCE la nouvelle page aux
 * lecteurs d'écran (une SPA ne recharge pas — sans ça, naviguer est muet).
 * L'arrivée initiale ne s'annonce pas (le navigateur lit déjà le titre).
 */
export function RouteAnnouncer() {
  const { pathname } = useLocation();
  const [message, setMessage] = useState('');
  const first = useRef(true);

  useEffect(() => {
    const title = titleFor(pathname);
    document.title = title;
    if (first.current) {
      first.current = false;
      return;
    }
    window.scrollTo({ top: 0, left: 0 });
    setMessage(title);
  }, [pathname]);

  return (
    <p aria-live="assertive" aria-atomic="true" className="sr-only">
      {message}
    </p>
  );
}
